import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { sanitizeId } from "../util";
import { BackgroundMode } from "../../../types/BackgroundMode";

import phaserGame from "../PhaserGame";
import Bootstrap from "../scenes/Bootstrap";

import { IPlayer } from "../../../types/IOfficeState";

export function getInitialBackgroundMode() {
  const currentHour = new Date().getHours();
  return currentHour > 6 && currentHour <= 18 ? BackgroundMode.DAY : BackgroundMode.NIGHT;
}

export const userSlice = createSlice({
  name: "userGame",
  initialState: {
    backgroundMode: getInitialBackgroundMode(),
    sessionId: "",
    videoConnected: false,
    backgroundMusic: false,
    loggedIn: false,
    textureName: "",
    playerX: 0,
    playerY: 0,
    namePlayer: "",
    checkLoggedIn: false,
    playerNameMap: new Map<string, string>(),
    playerLocMap: {},
    locationz: 0,
    idList: new Array(),
  },
  reducers: {
    toggleBackgroundMode: (state) => {
      const newMode = state.backgroundMode === BackgroundMode.DAY ? BackgroundMode.NIGHT : BackgroundMode.DAY;
      state.backgroundMode = newMode;
      const bootstrap = phaserGame.scene.keys.bootstrap as Bootstrap;
      bootstrap.changeBackgroundMode(newMode);
    },
    toogleBackgroundMusicOn: (state) => {
      phaserGame.sound.add("backgroundMusic", {
        volume: 0.2,
        loop: true,
      });
      phaserGame.sound.pauseOnBlur = false;
      const currentlyPlaying = phaserGame.sound.get("backgroundMusic");
      if (!state.backgroundMusic && currentlyPlaying) {
        state.backgroundMusic = true;
        currentlyPlaying.play();
      }
    },
    toogleBackgroundMusicOff: (state) => {
      const currentlyPlaying = phaserGame.sound.get("backgroundMusic");
      state.backgroundMusic = false;
      currentlyPlaying.stop();
    },
    setSessionId: (state, action: PayloadAction<string>) => {
      state.sessionId = action.payload;
    },
    setVideoConnected: (state, action: PayloadAction<boolean>) => {
      state.videoConnected = action.payload;
    },
    setLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.loggedIn = action.payload;
    },
    setTextureName: (state, action: PayloadAction<string>) => {
      state.textureName = action.payload;
    },
    setPlayerX: (state, action: PayloadAction<number>) => {
      state.playerX = action.payload;
    },
    setPlayerY: (state, action: PayloadAction<number>) => {
      state.playerY = action.payload;
    },
    setNamePlayer: (state, action: PayloadAction<string>) => {
      state.namePlayer = action.payload;
    },
    setPlayerNameMap: (state, action: PayloadAction<{ id: string; name: string }>) => {
      state.playerNameMap.set(sanitizeId(action.payload.id), action.payload.name);
    },
    removePlayerNameMap: (state, action: PayloadAction<string>) => {
      state.playerNameMap.delete(sanitizeId(action.payload));
    },
    setCheckLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.checkLoggedIn = action.payload;
    },
    updateOtherPlayerScene: (state, action: PayloadAction<{}>) => {
      if (state.playerLocMap[sanitizeId(action.payload[1])].locationz != undefined) {
        if (action.payload[0] == "x") {
          state.playerLocMap[sanitizeId(action.payload[1])].x = action.payload[2];
        } else if (action.payload[0] == "y") {
          state.playerLocMap[sanitizeId(action.payload[1])].y = action.payload[2];
        }
      }
    },
    setPlayerLocMap: (state, action: PayloadAction<{ id: string; player: IPlayer; locationz: number }>) => {
      state.playerLocMap[sanitizeId(action.payload.id)] = action.payload.player;
      state.playerLocMap[sanitizeId(action.payload.id)].locationz = action.payload.locationz;
      state.playerLocMap[sanitizeId(action.payload.id)].id = action.payload.id;
    },
    setNewPlayerLocMap: (state, action: PayloadAction<{ id: string; player: IPlayer; locationz: number; name: string }>) => {
      state.playerLocMap[sanitizeId(action.payload.id)] = action.payload.player;
      state.playerLocMap[sanitizeId(action.payload.id)].locationz = action.payload.locationz;
      state.playerLocMap[sanitizeId(action.payload.id)].id = action.payload.id;
      state.playerLocMap[sanitizeId(action.payload.id)].name = action.payload.name;
    },
    setLocationz: (state, action: PayloadAction<number>) => {
      state.locationz = action.payload;
    },
    setIdList: (state, action: PayloadAction<any>) => {
      state.idList.push(action.payload);
    },
    removeIdList: (state) => {
      state.idList = [];
    },
    removeIdOne: (state, action: PayloadAction<string>) => {
      const index = state.idList.indexOf(action.payload);
      if (index > -1) {
        state.idList.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
  },
});

export const {
  toggleBackgroundMode,
  toogleBackgroundMusicOn,
  toogleBackgroundMusicOff,
  setSessionId,
  setVideoConnected,
  setLoggedIn,
  setPlayerNameMap,
  removePlayerNameMap,
  setTextureName,
  setNamePlayer,
  setPlayerX,
  setPlayerY,
  setCheckLoggedIn,
  updateOtherPlayerScene,
  setPlayerLocMap,
  setNewPlayerLocMap,
  setLocationz,
  setIdList,
  removeIdList,
  removeIdOne,
} = userSlice.actions;

export default userSlice.reducer;
